export default (word, text) => {
    const indices = [];
    let result;
    const regexp = new RegExp('\\W' + word.replace(/\./g, '\\.') + '\\W', 'g');
    while (result = regexp.exec(` ${text} `)) {
        indices.push(result.index);
    }
    return indices;
};
//# sourceMappingURL=get_indices.js.map